import reactStringReplace from 'react-string-replace';

import { cn } from '@/shadcn/lib/utils';

import { PROSE_REGEX_MARKDOWN_BOLD } from '@/components/ui/prose/constants.prose';

type Props = {
  text: string;
  small?: boolean;
  className?: string;
};

export const Prose = ({ text, small = false, className }: Props) => {
  const parseBoldMarkdown = () =>
    reactStringReplace(text, PROSE_REGEX_MARKDOWN_BOLD, (match, i) => (
      <strong key={`bold_${i}`}>{match}</strong>
    ));

  return (
    <p
      className={cn(
        'text-sm [&>strong]:font-semibold',
        small && 'text-xs',
        className
      )}
    >
      {parseBoldMarkdown()}
    </p>
  );
};
